<template>
  <fts-modal
    append-to-body
    width="425px"
    :header="false"
    class="fts-information-delete-confirmation"
    @close="close"
    v-if="showDialog"
  >
    <!-- body -->
    <template #body>
      <template v-if="isForms">
        <div class="confirmation-title">Unable to delete Information</div>

        <div class="confirmation-description">
          Failed To delete
          <div class="information-group">
            <i
              :class="informationIcon"
              class="information-icon"
              v-if="informationIcon"
            ></i>
            <span>{{ information.displayName }}</span>
          </div>
          because there are other activities using this information.
        </div>

        <div class="activity-container">
          <div class="activity-container-label">
            Activities are using this information:
          </div>
          <div v-for="form in forms" :key="form.id" class="activity-group">
            <div class="activity-emoji" v-if="form.emoji">
              <fts-moji :emoji="form.emoji" :size="14" />
            </div>
            <div>{{ form.name }}</div>
          </div>
        </div>
      </template>

      <template v-else-if="type === 'remove'">
        <div class="confirmation-title">Remove Information?</div>

        <div class="confirmation-description">
          This will be removing the
          <div class="information-group">
            <i
              :class="informationIcon"
              class="information-icon"
              v-if="informationIcon"
            ></i>
            <span>{{ information.displayName }}</span>
          </div>
          from this form.
        </div>

        <div class="confirmation-card" v-if="!isAutoForms">
          This information doesn't use in other forms, you can choose to delete
          it instead of removing it from the form.
        </div>
      </template>

      <template v-else>
        <div class="confirmation-title">Delete Information?</div>

        <div class="confirmation-description">
          Permanently delete
          <div class="information-group">
            <i
              :class="informationIcon"
              class="information-icon"
              v-if="informationIcon"
            ></i>
            <span>{{ information.displayName }}</span>
          </div>
          . This cannot be undone.
        </div>
      </template>

      <template v-if="!isForms && isAutoForms">
        <div class="confirmation-card">
          This information is used in auto-generated form. Delete it will also
          remove this information from auto-generated form.
        </div>
      </template>
    </template>
    <!-- footer -->
    <template #footer>
      <div class="confirmation-footer">
        <fts-btn text text-transform-init @click="close" v-if="isForms">
          Close
        </fts-btn>

        <template v-else>
          <fts-btn text text-transform-init @click="close"> Cancel </fts-btn>

          <template v-if="type === 'remove'">
            <fts-btn
              color="danger"
              outline
              box-shadow-none
              text-transform-init
              @click="done"
            >
              Delete Information
            </fts-btn>

            <fts-btn
              color="danger"
              box-shadow-none
              text-transform-init
              @click="removeInformation"
            >
              Remove
            </fts-btn>
          </template>

          <fts-btn
            color="danger"
            box-shadow-none
            text-transform-init
            @click="done"
            v-else
          >
            Delete
          </fts-btn>
        </template>
      </div>
    </template>
  </fts-modal>
</template>

<script>
import commons from "../commons/commons";

import FTSModal from "../elements/FTSModal";
import FTSBtn from "../elements/FTSBtn";
import FTSMoji from "../elements/FTSMoji";
import formDesign from "../commons/formDesign";

export default {
  components: {
    "fts-modal": FTSModal,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMoji,
  },
  data: () => ({
    showDialog: false,
    resolve: null,
    information: null,
    forms: null,
    isAutoForms: false,
    type: null,
  }),
  methods: {
    async show({ canvas, information, forms, isAutoForms, payload, type }) {
      this.information = information;
      this.type = type;

      this.forms =
        forms !== null && forms !== undefined
          ? forms
          : formDesign.getFormsByInformationId(canvas, this.information.id, payload);

      this.isAutoForms =
        isAutoForms !== null && isAutoForms !== undefined
          ? isAutoForms
          : Array.isArray(canvas && canvas.standardActivities)
          ? formDesign.isAutoForms(canvas.standardActivities)
          : false;

      return new Promise(async (resolve) => {
        this.resolve = resolve;
        this.showDialog = true;
      });
    },
    close() {
      this.showDialog = false;
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    removeInformation() {
      this.resolve && this.resolve("remove");
      this.close();
    },
    done() {
      this.resolve && this.resolve(true);
      this.close();
    },
  },
  computed: {
    isForms() {
      return Boolean(this.forms && this.forms.length);
    },
    informationIcon() {
      return commons.informationIcon(this.information && this.information.type);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;

.fts-information-delete-confirmation {
  .information-group {
    display: inline-flex;
    align-items: flex-start;
    font-weight: 500;
    vertical-align: top;
    word-break: break-word;
    .information-icon {
      margin-right: 0.25rem;
      line-height: 1.5;
    }
  }
  .activity-container {
    margin-top: 1.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
  }
  .activity-container-label {
    margin-bottom: 0.5rem;
  }
  .activity-group {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.5rem;
    word-break: break-word;
    .activity-emoji {
      min-height: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.5rem;
    }
  }
  .confirmation-title {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5;
  }
  .confirmation-description {
    font-size: 0.875rem;
    line-height: 1.5;
    &:not(:first-child) {
      margin-top: 0.5rem;
    }
  }
  .confirmation-card {
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
    background-color: var(--fts-gray-100);
    &:not(:first-child) {
      margin-top: 1rem;
    }
  }
  .confirmation-footer {
    @include flex-gap($gap: 0.5rem);
    justify-content: flex-end;
  }
}
</style>